import { useEffect, useState } from 'react'

const canMatch = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function'

/**
 * Whether a media query matches, kept current as the window resizes. Where
 * matchMedia does not exist (tests, very old browsers) it answers `fallback`.
 */
export function useMediaQuery(query: string, fallback = true): boolean {
  const [matches, setMatches] = useState(() => (canMatch() ? window.matchMedia(query).matches : fallback))

  useEffect(() => {
    if (!canMatch()) return
    const mql = window.matchMedia(query)
    const update = () => setMatches(mql.matches)
    update()
    mql.addEventListener('change', update)
    return () => mql.removeEventListener('change', update)
  }, [query])

  return matches
}
